export const getFrameDim = (height, width, maxHeight, maxWidth) => {
    // console.log("In getFrameDim");
    // console.log(maxWidth);
    // console.log(maxHeight);
    // console.log(width);
    // console.log(height);
    if (!width) width = maxWidth;
    if (!height) height = maxHeight;
    if (width > maxWidth && height > maxHeight) {
    //   console.log(width);
    //   console.log(height);
      let wDiff = (width - maxWidth)/width;
      let hDiff = (height - maxHeight)/height;
      if (wDiff >= hDiff) {
        height = (1-wDiff)*height;
        width = (1-wDiff)*width;
      } else {
        height = (1-hDiff)*height;
        width = (1-hDiff)*width;
      }
    } else if (width > maxWidth) {
      let wDiff = (width - maxWidth)/width;
      width = (1-wDiff)*width;
      height = (1-wDiff)*height;
    } else if (height > maxHeight) {
      let hDiff = (height - maxHeight)/height;
      height = (1-hDiff)*height;
      width = (1-hDiff)*width;
    } else {
      // width and height must be less than the screen width and height
      let wDiff = (maxWidth - width)/width;
      let hDiff = (maxHeight - height)/height;
      if (wDiff >= hDiff) {
        height = (1+hDiff)*height;
        width = (1+hDiff)*width;
      } else {
        height = (1+wDiff)*height;
        width = (1+wDiff)*width;
      }
    }
    // console.log(`Debug Log: new width: ${width}`)
    // console.log(`Debug Log: new height: ${height}`)
    return {width: width, height: height}
  }